// GAVION ai-email (spec §6): the count of the user's pending drafts on the « Brouillons » nav item.
import { useTranslate } from "ra-core";
import { SidebarMenuBadge } from "@/components/ui/sidebar";
import { usePendingDraftCount } from "./useAiDrafts";

export const DraftsNavBadge = () => {
  const t = useTranslate();
  const n = usePendingDraftCount();
  if (n === 0) return null;
  return (
    <SidebarMenuBadge
      aria-label={t("gavion.ai.drafts.badge", { smart_count: n })}
    >
      {n > 99 ? "99+" : n}
    </SidebarMenuBadge>
  );
};
